import * as React from "react";
const SvgBpUploadIcon = (props) => /* @__PURE__ */ React.createElement("svg", { id: "uuid-f112512e-cdb6-4b6e-9bb7-206ae42416d7", "data-name": "Warstwa 1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "m7,1c-1.1,0-2,.9-2,2v14c0,1.1.9,2,2,2h14c1.1,0,2-.9,2-2V3c0-1.1-.9-2-2-2H7Zm12,3h-10v1h10v-1Zm-6.5,7.5v4h3v-4h2.5l-4-4.5-4,4.5h2.5Zm2-1v4h-1v-4h-1l1.5-1.5,1.5,1.5h-1Z", style: {
  fill: "CurrentColor",
  fillRule: "evenodd",
  strokeWidth: 0
} }), /* @__PURE__ */ React.createElement("path", { d: "m3,19V4h1v15c0,.55.45,1,1,1h15v1H5c-1.1,0-2-.9-2-2Z", style: {
  fill: "CurrentColor",
  fillRule: "evenodd",
  strokeWidth: 0
} }), /* @__PURE__ */ React.createElement("path", { d: "m1,21V6h1v15c0,.55.45,1,1,1h15v1H3c-1.1,0-2-.9-2-2Z", style: {
  fill: "CurrentColor",
  fillRule: "evenodd",
  strokeWidth: 0
} }));
export default SvgBpUploadIcon;
